import React from 'react'
import useFetch from '../hooks/useFetch'
import { baseUrl } from '../assets/Animations'
import "./temp-dashboard.css"

const TempDashboard = () => {
    const {data: families, loading: gettingStudents, error: testStudentError} = useFetch(`${baseUrl}/school-management`)
    const {data: instruments, loading: gettingInstruments, error: testInstError} = useFetch(`${baseUrl}/inst`)
    const [myMap, setMyMap] = React.useState({})

    React.useEffect(() => {
        let theMap = {}
        if(families.length > 0) {
            for(let i = 0; i < families.length; i++) {
                for(let k = 0; k < families[i].students.length; k++) {
                    for(let j = 0; j < families[i].students[k].instrumentList.length; j++) {
                      if(theMap[families[i].school]) {
                        if(theMap[families[i].school][families[i].students[k].studentStatus]) {
                          if(theMap[families[i].school][families[i].students[k].studentStatus][families[i].students[k].instrumentList[j].parentInstrument]) {
                              theMap[families[i].school][families[i].students[k].studentStatus][families[i].students[k].instrumentList[j].parentInstrument] = theMap[families[i].school][families[i].students[k].studentStatus][families[i].students[k].instrumentList[j].parentInstrument] + 1
                              theMap[families[i].school][families[i].students[k].studentStatus]['Total'] = theMap[families[i].school][families[i].students[k].studentStatus]['Total'] + 1
                          } else {
                              theMap[families[i].school][families[i].students[k].studentStatus][families[i].students[k].instrumentList[j].parentInstrument] = 1
                              if(theMap[families[i].school][families[i].students[k].studentStatus]['Total']) {
                                theMap[families[i].school][families[i].students[k].studentStatus]['Total'] = theMap[families[i].school][families[i].students[k].studentStatus]['Total'] + 1
                              } else {
                                theMap[families[i].school][families[i].students[k].studentStatus]['Total'] = 1
                              }
                          }
                        } else {
                            theMap[families[i].school][families[i].students[k].studentStatus] = {[families[i].students[k].instrumentList[j].parentInstrument]: 1}
                        }
                      } else {
                        theMap[families[i].school] = {[families[i].students[k].studentStatus]: {[families[i].students[k].instrumentList[j].parentInstrument]: 1}}
                      }
                    }
                }
            }
            setMyMap(theMap)
        }
    }, [families])
    return (
        <div className='temp-dashboard-wrapper'>
          {Object.keys(myMap).map((school, index) => {
            return (
              <div>
                { school !== 'GLMA' &&
                <div key={index} className="temp-dashboard-wrapper__school-section">
                <div className="temp-dashboard-wrapper__school-name">{school}</div>
                      {Object.keys(myMap[school]).map((status, index2) => (
                          <div className='temp-dashboard-wrapper__status-section' key={index2}>
                            <div className='temp-dashboard-wrapper__status-name'>{status}: {myMap[school][status]['Total']}</div>
                            {Object.keys(myMap[school][status]).map((inst, index3) => (
                                <div className='temp-dashboard-wrapper__inst-section' key={index3}>
                                  { inst !== 'Total' && 
                                    <div>
                                      <div className='temp-dashboard-wrapper__inst-name'>{inst}:</div>
                                      <div className='temp-dashboard-wrapper__inst-total'>{myMap[school][status][inst]}</div>
                                    </div>
                                  }
                                </div>
                            ))}
                          </div>
                      ))}
              </div>
                }
              </div>
            );
          })}
        </div>
      );
}
export default TempDashboard